export default "__VITE_ASSET__816140ca__"